// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_STICKER_VALUES = {
  bgColor: "#FFFFFF",
  paddingSize: "medium",
  shape: "die-cut",
  width: 1,
  height: 1,
  quantity: 10
};
